import { COLORS } from '@btime/constants'
import { propEq } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Text, Title } from '../../../../components/presentation/Text'
import { useOpenExportModal } from '../../../../utils/routes/modals/modalsActions'
import { usePlaceTypes } from '../../../../utils/helpers/placeTypes'
import Center from '../../../../components/helpers/Center'
import Icon from '../../../../components/shapes/Icon'
import IconButton from '../../../../components/actions/IconButton'
import Separator from '../../../../components/helpers/Separator'
import SeparatorWrapper from '../../../../components/helpers/SeparatorWrapper'

const SideBar = ({ entity }) => {
  const { t } = useTranslation('import')

  const openExportModal = useOpenExportModal()
  const [placeTypes] = usePlaceTypes()

  const type = entity
  entity = placeTypes.some(propEq('key', entity)) ? 'place' : entity
  let filter = undefined
  if (entity === 'place') filter = { types: [type] }

  return (
    <SeparatorWrapper weight={4}>
      <Center>
        <Icon name="BsFillInfoCircleFill" color={COLORS.dark3} size="3rem" />
        <Separator weight={6} />
        <Title size="h4" align="center">
          {t('importInstructions')}
        </Title>
        <Text align="center">{t('importInstructionsDescription')}</Text>
        <Separator weight={6} />

        <IconButton
          label={t('downloadTemplate')}
          icon="RiDownloadCloud2Line"
          transparent
          onClick={() => openExportModal({ entity, empty: true, filter })}
        />
      </Center>
      <Separator weight={60} />
    </SeparatorWrapper>
  )
}

export default SideBar
